export default __webpack_public_path__ + "static/media/Arm-straps of the Ubah Kan.6f907f98.jpg";